export const IconBasePath = 'assets/icons/';

export const ICONS = {
  arrow_back: 'arrow_back.svg',
  arrow_back_ios: 'arrow_back_ios.svg',
  arrow_drop_down: 'arrow_drop_down.svg',
  arrow_drop_down_rounded: 'arrow_drop_down_rounded.svg',
  arrow_drop_up: 'arrow_drop_up.svg',
  arrow_forward: 'arrow_forward.svg',
  arrow_forward_ios: 'arrow_forward_ios.svg',
  arrow_left: 'arrow_left.svg',
  arrow_right: 'arrow_right.svg',
  check: 'check.svg',
  check_circle: 'check_circle.svg',
  check_circle_outline: 'check_circle_outline.svg',
  chevron_left: 'chevron_left.svg',
  chevron_right: 'chevron_right.svg',
  close_rounded: 'close_rounded.svg',
  call_made: 'call_made.svg',
  done: 'done.svg',
  expand_less: 'expand_less.svg',
  expand_more: 'expand_more.svg',
  favorite: 'favorite.svg',
  group_outline: 'group_outline.svg',
  group_rounded: 'group_rounded.svg',
  help_outline: 'help_outline.svg',
  info: 'info.svg',
  lock: 'lock.svg',
  lock_outline: 'lock_outline.svg',
  menu: 'menu.svg',
  pets: 'pets.svg',
  search: 'search.svg',
  star: 'star.svg',
  translate: 'translate.svg',
  verified: 'verified.svg',
  visibility: 'visibility.svg',
  visibility_off: 'visibility_off.svg',
  volunteer_activism: 'volunteer_activism.svg'
} as const;

export type IconName = keyof typeof ICONS;